import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import PositionedEffect from '../../../domain/entities/PositionedEffect';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexPositionedEffectsSuccess: {
      const result = action.payload as PaginatedResult<PositionedEffect>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
